export const PASSWORD_RULES = [
  "Minimum 10 characters",
  "At least one lowercase letter",
  "At least one uppercase letter",
  "At least one number",
  "At least one symbol character",
];

export function validatePassword(password, confirmation) {
  if (!password) return "Password is required.";
  if (password.length < 10) return PASSWORD_RULES[0] + ".";
  if (!/[a-z]/.test(password)) return PASSWORD_RULES[1] + ".";
  if (!/[A-Z]/.test(password)) return PASSWORD_RULES[2] + ".";
  if (!/\d/.test(password)) return PASSWORD_RULES[3] + ".";
  if (!/[^A-Za-z0-9]/.test(password)) return PASSWORD_RULES[4] + ".";
  if (password !== confirmation) return "Passwords do not match.";
  return "";
}
